module.exports = __webpack_public_path__ + "static/media/flag-la.31bf938c.webp";